export default __webpack_public_path__ + "static/media/pesonalsubmenuImage.71b39f90.webp";